module.exports = __webpack_public_path__ + "static/r9-71f915237037655aaae52937a27298a9.jpg";